import _ from 'lodash'
import type { BreakpointsToCssWithMedia } from '../../types'

export const mergeCssWithMediaArray = (array: Array<BreakpointsToCssWithMedia>) =>
	array.reduce(_.merge, {}) as BreakpointsToCssWithMedia

export { layoutDataItemToCss, pinnedLayerDataItemToCss } from './layoutToCss'
